export default __webpack_public_path__ + "static/media/actoctt-bold-webfont.31905dfb.woff2";